<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/a8f4PA/images/cover.jpg?1684979358673" alt="This image is the cover for the book The Letters of John, The Pillar New Testament Commentary (PNTC)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Letters of John, The Pillar New Testament Commentary (PNTC)
      </h1>
      <p class="bookDescription body article font2">
        <p>Based on the latest text of the NIV, this updated commentary reflects the most current scholarship.</p><p>This updated and revised Pillar commentary seeks to clearly explain the meaning of the letters of John to teachers, pastors, and general readers looking for a reliable and trusted resource for personal study. Colin Kruse introduces the important issues involved in interpreting the Johannine letters, gives verse-by-verse comments, and provides extensive discussion of major theological themes, including the real humanity of Christ, atonement, the role of the Spirit, Christian assurance, <i>koinōnia</i>, Christian love, and eternal life. </p><p>The Pillar New Testament Commentary, designed for serious readers of the Bible, seeks above all to make clear the meaning of the text of Scripture as we have it. Writers of the PNTC volumes interact with the most important, informed contemporary debate yet avoid undue technical detail. Their ideal is a blend of rigorous exegesis and exposition, scholarship and pastoral sensitivity, with an eye alert both to biblical theology and to the contemporary relevance of the Bible.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Colin G. Kruse
      </h2>
      
      <p class="authorDescription body article">Colin G. Kruse is senior lecturer in New Testament at Melbourne School of Theology, Australia. His other books include the Tyndale New Testament Commentary volumes on John and 2 Corinthians and the Pillar New Testament Commentary volume on the letters of</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?07f5a2a6